export default __webpack_public_path__ + "static/media/Grupo3946.6207e315.svg";